import Compressor from 'compressorjs';

export const compressImage = async (
	addedFile: File,
	setImage: (image: string) => void,
	setFile: (file: File) => void,
	setResizedFile: (file: File) => void
) => {
	let compQuality = 0.9;
	if (addedFile.size > 8000000) compQuality = 0.6;
	else if (addedFile.size > 6000000) compQuality = 0.7;
	else if (addedFile.size > 4000000) compQuality = 0.8;
	// else if (addedFile.size > 3000000) compQuality = 0.9;
	else if (addedFile.size < 1000000) compQuality = 1;
	new Compressor(addedFile, {
		quality: compQuality, // its not recommended to go below 0.6 .
		maxWidth: 3500,
		maxHeight: 3500,
		resize: 'contain',

		success: (compressedResult) => {
			const url = URL.createObjectURL(compressedResult);
			setImage(url);
			const compressedFile = new File([compressedResult], addedFile.name);
			setFile(compressedFile);
		}
	});

	new Compressor(addedFile, {
		quality: 0.8, // the quality of the image, max is 1,
		maxWidth: 400, // the max width of the output image, defaults to 1920px
		maxHeight: 400, // the max height of the output image, defaults to 1920px
		resize: 'contain', // defaults to true, set false if you do not want to resize the image width and height

		success: (compressedResult) => {
			const compressedFile = new File([compressedResult], addedFile.name);
			setResizedFile(compressedFile);
		}
	});
};
